
import * as THREE from 'three';

export class Line2 {
    constructor( start, end ) {
		this.start = (start !== undefined) ? start : new THREE.Vector2();
		this.end = (end !== undefined) ? end : new THREE.Vector2();
        this._startP = new THREE.Vector2();
        this._startEnd = new THREE.Vector2();
    }

    set(start, end) {
		this.start.copy( start );
		this.end.copy( end );
		return this;
    }

    delta(target) {
		if (target === undefined) {
			console.warn('THREE.Line3: .delta() target is now required');
			target = new Vector3();
		}
		return target.subVectors(this.end, this.start);
	}

	at(t, target) {
		if (target === undefined) {
			console.warn( 'THREE.Line3: .at() target is now required' );
			target = new THREE.Vector2();
		}
		return this.delta(target).multiplyScalar(t).add(this.start);
	}
    
    closestPointToPointParameter(point, clampToLine) {
		this._startP.subVectors( point, this.start );
		this._startEnd.subVectors( this.end, this.start );

		const startEnd2 = this._startEnd.dot(this._startEnd);
		const startEnd_startP = this._startEnd.dot(this._startP);

		let t = startEnd_startP / startEnd2;

		if (clampToLine) {
			t = THREE.MathUtils.clamp(t, 0, 1);
		}

		return t;
    }
    
    closestPointToPoint(point, clampToLine, target) {
		const t = this.closestPointToPointParameter(point, clampToLine);
		if ( target === undefined ) {
			console.warn( 'THREE.Line3: .closestPointToPoint() target is now required' );
			target = new THREE.Vector2();
		}

		return this.delta(target).multiplyScalar(t).add(this.start);
    }

    isNear(point, maxDist) {
        const t = this.closestPointToPointParameter(point);
        if (t >= 0 && t <= 1) {
            let target = new THREE.Vector2();
            this.delta(target).multiplyScalar(t).add(this.start);
            return target.distanceTo(point) < maxDist;
        }
        return false;
    }
    
    closestDistanceToPoint(point, clampToLine) {
        let target = new THREE.Vector2();
        this.closestPointToPoint(point, clampToLine, target);
        return target.distanceTo(point);
    }
}



// WEBPACK FOOTER //
// ./src/views/reliefVase/scripts/Line2.js